module.exports = __webpack_public_path__ + "img/hxh_2.b7ad337b.gif";